<template>
    <div class="col-sm-12 list-content-item mb-2">
        <div class="row">
            <div class="col-auto image-container">
                <avatar-badge :src="displayImage" :raised="false" :size="100"></avatar-badge>
            </div>
            <div class="col">
                <div class="row">
                    <div class="col-lg-9">
                        <h2 class="title" v-text="service.name"></h2>
                    </div>
                    <div class="col-lg-3 text-lg-right text-left mt-sm--2 mt-lg-0">
                        PHP<span class="text-lg" v-text="displayedPrice"></span>
                    </div>
                </div>

                <div class="description mb-2" v-if="service.type == 'service'">{{ category.name }} - {{ subcategory.name }}</div>
                <div class="description mb-2" v-else v-text="displayedPackageItems"></div>

                <div class="description text-default">Duration: {{ displayedDuration }} <span class="text-muted">(each)</span></div>
                <div v-if="quantity > 0 && service.type == 'service'" class="description text-default ">
                    Selected experts:
                        <span v-if="selectedExperts.length > 0" v-text="displayedExperts"></span>
                        <span v-else class="text-muted">No experts selected</span>
                </div>
                <div v-if="quantity > 0" class="description text-default ">Quantity: {{ quantity }}</div>
                <div v-if="isAvailable" class="text-right">
                    <template v-if="isPresentInList">
                        <button @click.prevent="removeService" class="btn btn-sm btn-danger">
                            <i class="fa fa-trash mr-1"></i> Delete
                        </button>
                        <button @click.prevent="addService" class="btn btn-sm btn-warning">
                            <i class="fa fa-pen mr-1"></i> Edit 
                        </button>
                    </template>
                    <template v-else>
                        <button @click.prevent="addService" class="btn btn-sm btn-warning">
                            <i class="fa fa-eye mr-1"></i> Add 
                        </button>
                    </template>
                </div>
                <div v-else class="text-right">
                    <span class="text-muted">No experts available</span>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { bus } from "@utils/bus";
import moment from "moment";
import { getDisplayedDuration } from "@utils/helpers";

export default {
    name: "ServiceListItem",

    computed: {
        displayImage() {
            return this.service.display_image || "/images/placeholders/avatar.jpg";
        },
        displayedPrice() {
            return parseFloat(this.service.price || 0).toFixed(2);
        },
        subcategory() {
            return this.service.subcategory || {};
        },
        category() {
            return this.subcategory.category || {};
        },
        displayedPackageItems() {
            return this.service.packageItems
                ? this.service.packageItems.map(item => item.name).join(", ")
                : "";
        },
        displayedDuration() {
            return getDisplayedDuration(this.service.duration || 0);
        },
        isPresentInList() {
            const list = this.getServiceList();

            return list.findIndex(item => item.id == this.service.id) >= 0;
        },
        displayedExperts() {
            return this.selectedExperts.length > 0
                ? this.selectedExperts.map(expert => expert.fullname).join(", ")
                : "No experts selected";
        },
    },

    data: () => ({
        quantity: 0,
        selectedExperts: [],
    }),

    methods: {
        addService() {
            this.$emit("add", this.service);
        },
        removeService() {
            this.quantity = 0;
            this.selectedExperts = [];
            this.$emit("remove", this.service);
        },
        getServiceList() {
            return this.service.type == "package"
                ? this.$parent.$parent.packages
                : this.$parent.$parent.services;
        },
        refreshService() {
            const list = this.getServiceList();
            const index = list.findIndex(item => item.id == this.service.id);
            
            if (index < 0) return;

            this.quantity = list[index].quantity;
            this.refreshExperts(list[index]);
        },
        refreshExperts(service) {
            if (this.service.type == "package") return;
            if (!Array.isArray(service.selectedExperts) || service.selectedExperts.length == 0) return;

            this.selectedExperts = [...service.selectedExperts];
        },
    },
    
    props: {
        service: [Object],
        isAvailable: Boolean,
    },

    mounted() {
        bus.$on(`service-updated-${ this.service.id }`, this.refreshService);
        this.refreshService();
    },

    beforeDestroy() {
        bus.$off(`service-updated-${ this.service.id }`);
    }
}
</script>